/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Ember from 'ember';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import RouterService from '@ember/routing/router-service';
import { wait } from 'ember-animated';
import Sprite from 'ember-animated/-private/sprite';

interface MainNavListArgs {
  icon: string;
  title: string;
  expandable: boolean;
  isExpanded: boolean;
}

const COLLAPSE_DURATION = 200;

export default class MainNavList extends Component<MainNavListArgs> {
  @service router!: RouterService;

  readonly collapseTransitionDuration = COLLAPSE_DURATION;

  @tracked isExpanded = false;

  constructor(owner: unknown, args: MainNavListArgs) {
    super(owner, args);

    this.resetDropdownState();

    this.router.on('routeDidChange', this.resetDropdownState);
  }

  @action
  resetDropdownState() {
    // No `off` method to unregister an event, so we have to check if the
    // has been destroyed instead
    if (this.isDestroyed) {
      return;
    }

    this.isExpanded = this.args.isExpanded;
  }

  *collapseTransition({ removedSprites }: { removedSprites: Sprite[] }) {
    // This makes sure the disappearing panel body doesn't disappear instantly.
    // Otherwise the container will be empty while it animates, which we don't
    // want.
    // eslint-disable-next-line
    for (let _ of removedSprites) {
      if (!Ember.testing) {
        yield wait(COLLAPSE_DURATION);
      }
    }
  }
}
